export const routes = {
  home: "/",
  signedOut: "/signed-out",
} as const;
